var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM17.8851 7.81944C18.0615 7.607 18.0323 7.29177 17.8198 7.11535C17.6074 6.93893 17.2922 6.96814 17.1157 7.18058L9.48479 16.3699C9.28486 16.6107 8.9154 16.6107 8.71547 16.3699L5.88468 12.961C5.70826 12.7486 5.39303 12.7194 5.18058 12.8958C4.96814 13.0722 4.93893 13.3875 5.11535 13.5999L7.94614 17.0088C8.54594 17.7311 9.65433 17.7311 10.2541 17.0088L17.8851 7.81944Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSuccess);
export default __webpack_public_path__ + "static/media/ico-success.e9d58164dbf647f593124850760ddd35.svg";
export { ForwardRef as ReactComponent };